import { Button, IconButton, Paper } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useState } from 'react';


export function MultiSelectWithIconButton({ options, initialOptionState, icon, action, clearAll, clearAllLabel }) {

    const [optionsState, setOptionsState] = useState([]);
    React.useEffect(() => {
        // console.log(optionsState);
        // console.log(initialOptionState);
        // console.log(clearAllLabel);
        if (initialOptionState) {
            setOptionsState(initialOptionState);
        } else {
            setOptionsState([]);
        }
    }, [initialOptionState]);

    const onChange = (event, value) => {
        if (clearAllLabel && value.includes(clearAllLabel)) {
            setOptionsState([]);
            action([]);
            clearAll();
        } else {
            setOptionsState(value);
            action(value, event);
        }
        console.log(event);
    };

    const getOptions = () => {
        if (clearAllLabel) {
            return [clearAllLabel, ...options];
        } else {
            return options;
        }
    };

    const getOptionSelected = (option, value) => {
        // if (option.label === value.label) {
        //     console.log("option: " + option.label);
        //     console.log("value: " + value.label);
        // }
        return option.label === value.label;
    }

    return (
        <Autocomplete
            multiple
            value={optionsState}
            className='autocompleteFilter'
            id="autocomplete-filter"
            size='small'
            options={getOptions()}
            // dense={true}
            disableCloseOnSelect
            disablePortal
            onChange={onChange}
            getOptionSelected={getOptionSelected}
            getOptionLabel={(option) => option ? option.label : ''}
            renderOption={renderOption(clearAllLabel, optionsState)}
            PaperComponent={DropDownListRenderer}
            renderInput={(params) => <MyComp {...params} icon={icon} />}
        />
    )
}

const incl = (obj, id) => {
    let incl = false;
    if (obj) {
        /* eslint-disable array-callback-return */
        obj.map(o => {
            if (o.value === id.value) {
                incl = true;
            }
        })
    } else {
        return false;
    }
    return incl;
}

function renderOption(clearAllLabel, optionsState) {
    return (option, state) => {
        return (
            clearAllLabel && clearAllLabel === option ?
                <div><Button>{option.label}</Button></div>
                :
                <div className='autocomplete-filter-option'>
                    <Checkbox
                        color="primary"
                        className='autocomplete-filter-checkbox'
                        size='small'
                        checked={incl(optionsState, option)} />
                    {option.label}
                </div>
        );
    };
}

function MyComp(params) {
    return (
        <div ref={params.InputProps.ref}>
            <IconButton disableRipple disableFocusRipple style={{ backgroundColor: "transparent" }} {...params.inputProps}>
                {params.icon}
            </IconButton>
        </div >
    )
};

const DropDownListRenderer = ({ children, ...other }) => (
    <div className="actions-dropdown-list">
        <Paper {...other} variant='elevation'>
            {children}
        </Paper>
    </div>
);